/* ==========================================================================
   prinsert-swatch-more.js
   --------------------------------------------------------------------------
   Setzt das "noch mehr Farben"-Feld in gedeckelte Farbpunktreihen.

   AUFGABE: Wo die Reihe auf eine Zeile begrenzt ist, soll die LETZTE
   Farbe der ersten Zeile durch ein Plus-Feld ersetzt werden, das auf die
   Produktseite fuehrt. Ohne das waere nicht erkennbar, dass es weitere
   Farben gibt -- die Kachel sieht dann so aus, als waeren es genau diese.

   ==========================================================================
   WARUM DAS NICHT IN CSS GEHT

   Wie viele Felder in eine Zeile passen, entscheidet erst der Umbruch --
   und der haengt an der Kachelbreite, also an der Fensterbreite. CSS kann
   das weder zaehlen noch darauf reagieren. Deshalb wird gemessen:
   Elemente mit demselben offsetTop wie das erste stehen in der ersten
   Zeile, alle anderen darunter.

   SELBSTBEGRENZEND: Das Skript prueft, ob der Container ueberhaupt
   beschneidet (scrollHeight groesser als clientHeight). Nur dann greift
   es. Auf Kollektionsseiten steht kein Deckel, dort passiert nichts --
   ohne dass hier eine Sektion fest verdrahtet werden muesste. Wird der
   Deckel in prinsert-custom.css spaeter auf weitere Bereiche ausgedehnt,
   wirkt das Feld dort automatisch mit.

   ==========================================================================
   FALLEN, DIE HIER BEDACHT SIND

   ZURUECKSETZEN VOR DEM MESSEN. Bei jedem Durchlauf werden zuerst das alte
   Plus-Feld entfernt und alle Farbfelder wieder eingeblendet. Sonst
   entstuende beim Verkleinern und Wiedervergroessern des Fensters eine
   Kette aus Resten, und die Messung liefe auf einem Zustand, den das
   Skript selbst erzeugt hat.

   GLEICHE MASSE, DAMIT DIE RECHNUNG STIMMT. Das Plus-Feld ersetzt genau
   ein Farbfeld und ist genauso gross (siehe prinsert-swatches.css). Waere
   es breiter, veraenderte es den Umbruch -- also die Groesse, aus der es
   gerade berechnet wurde.

   ES TRAEGT NICHT DIE KLASSE .card__swatch. Gezaehlt wird ueber diese
   Klasse; ein Plus-Feld mit derselben Klasse zaehlte sich selbst mit.

   MINDESTENS ZWEI FELDER IN DER ERSTEN ZEILE. Sonst bliebe nach dem
   Ersetzen keine einzige Farbe sichtbar, und die Kachel zeigte nur noch
   ein Plus. In dem Fall bleibt es beim schlichten Beschnitt.

   TOLERANZ BEIM VERGLEICH. offsetTop ist eine ganze Zahl, aber
   Unterschiede von einem Pixel koennen durch Rundung entstehen. Deshalb
   wird mit 2px Toleranz verglichen statt auf Gleichheit.

   KEIN ResizeObserver. Der wuerde beim eigenen Eingriff erneut feuern.
   Stattdessen: einmal beim Laden, einmal nach dem vollstaendigen Laden
   (Schriften und Bilder aendern die Breiten noch) und danach entprellt
   bei Groessenaenderung.
   ========================================================================== */

(function () {
  if (window.__prinsertSwatchMoreInit) return;
  window.__prinsertSwatchMoreInit = true;

  var KLASSE = 'card__swatch-more';
  var TOLERANZ = 2;

  function produktUrl(reihe) {
    var kachel = reihe.closest('.card-wrapper');
    if (!kachel) return null;
    var link = kachel.querySelector('.card__heading a');
    return link ? link.getAttribute('href') : null;
  }

  function bearbeite(reihe) {
    /* 1. Sauberen Ausgangszustand herstellen. */
    var altes = reihe.querySelector('.' + KLASSE);
    if (altes) altes.parentNode.removeChild(altes);

    var felder = Array.prototype.slice.call(reihe.querySelectorAll('.card__swatch'));
    felder.forEach(function (feld) {
      feld.style.display = '';
    });

    if (felder.length < 2) return;

    /* 2. Beschneidet der Container ueberhaupt? Wenn nicht, ist nichts zu
       verbergen und das Plus waere eine Luege. */
    if (reihe.scrollHeight <= reihe.clientHeight + TOLERANZ) return;

    /* 3. Erste Zeile bestimmen. */
    var obenKante = felder[0].offsetTop;
    var ersteZeile = felder.filter(function (feld) {
      return Math.abs(feld.offsetTop - obenKante) <= TOLERANZ;
    });

    if (ersteZeile.length === felder.length) return;
    if (ersteZeile.length < 2) return;

    /* 4. Letztes Feld der ersten Zeile durch das Plus ersetzen. */
    var verborgen = felder.length - (ersteZeile.length - 1);
    var letztes = ersteZeile[ersteZeile.length - 1];
    var ziel = produktUrl(reihe);

    var plus = document.createElement('a');
    plus.className = KLASSE;
    plus.href = ziel || '#';
    plus.title = verborgen + ' weitere Farben ansehen';
    plus.setAttribute('aria-label', verborgen + ' weitere Farben ansehen');

    var zeichen = document.createElement('span');
    zeichen.setAttribute('aria-hidden', 'true');
    zeichen.textContent = '+';
    plus.appendChild(zeichen);

    letztes.style.display = 'none';
    reihe.insertBefore(plus, letztes);
  }

  function alle() {
    var reihen = document.querySelectorAll('.card__swatches');
    Array.prototype.forEach.call(reihen, function (reihe) {
      try {
        bearbeite(reihe);
      } catch (e) {
        /* Eine einzelne Kachel darf nie die uebrigen mitreissen. */
      }
    });
  }

  var wartet = null;
  function entprellt() {
    if (wartet) clearTimeout(wartet);
    wartet = setTimeout(alle, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  /* Schriften und Bilder aendern die Breiten noch nach DOMContentLoaded. */
  window.addEventListener('load', alle);
  window.addEventListener('resize', entprellt);
  window.addEventListener('orientationchange', entprellt);

  /* Der Theme-Editor baut Sektionen neu auf, ohne die Seite zu laden. */
  document.addEventListener('shopify:section:load', alle);
})();
